<template>
  <div>
    <div class="modal fade" id="AddZleceniaModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pracownicy - zlecenia</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Lista pracowników (zlecenie)</h6>
              <button class="btn btn-sm btn-success" @click="addZlecenie"><i class="bi bi-plus-lg me-1"></i> Dodaj
                pracownika</button>
            </div>
            <div class="custom-table">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Imię</th>
                    <th>Nazwisko</th>
                    <th>Użyty</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
				  <tr v-if="addingNew">
                    <td>Nowy</td>
                    <td><input v-model="newZlecenie.first_name" class="form-control" /></td>
                    <td><input v-model="newZlecenie.last_name" class="form-control" /></td>
                    <td>
                      <button @click="saveNewZlecenie" class="btn btn-sm btn-success me-1"><i
                          class="bi bi-save me-2"></i>Zapisz
                      </button>
                      <button @click="cancelNewZlecenie" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2"></i>Anuluj
                      </button>
                    </td>
                  </tr>
                 <tr v-for="(zlecenie, index) in zleceniaLista" :key="zlecenie.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === zlecenie.id" v-model="zlecenie.first_name" class="form-control" />
                      <span v-else>{{ zlecenie.first_name }}</span>
                    </td>
                    <td>
                      <input v-if="editingId === zlecenie.id" v-model="zlecenie.last_name" class="form-control" />
                      <span v-else>{{ zlecenie.last_name }}</span>
                    </td>
                    <td>{{ zlecenie.delegacje_count }}</td>
                    <td>
                      <button v-if="editingId === zlecenie.id" @click="updateZlecenie(zlecenie)" class="btn btn-sm btn-success me-2">
                        Zapisz
                      </button>
                      <button v-else @click="editZlecenie(zlecenie.id)" class="btn btn-sm btn-outline-info me-2"><i
                          class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button v-if="zlecenie.delegacje_count === 0" @click="deleteZlecenie(zlecenie.id)" class="btn btn-sm btn-danger">
                        <i class="bi bi-trash me-2"></i>Usuń
                      </button>					  
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Modal } from 'bootstrap';

export default {
props: {
  zlecenia: {
    type: [Array, Object],
    default: () => []
  }
},

  data() {
    return {
      modalObj: null,
      editingId: null,
      addingNew: false,
      newZlecenie: this.getEmptyForm()
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },
computed: {
    zleceniaLista() {
        return Array.isArray(this.zlecenia)
            ? this.zlecenia
            : [];
    }
},
  methods: {
    resetForm() {
      this.editingId = null;
      this.addingNew = false;
      this.newZlecenie = this.getEmptyForm();
    },
    getEmptyForm() {
      return {
        id: null,
        first_name: '',
        last_name: ''
      };
    },

    addZlecenie() {
      this.addingNew = true;
      this.newZlecenie = this.getEmptyForm();
    },

    cancelNewZlecenie() {
      this.addingNew = false;
      this.newZlecenie = this.getEmptyForm();
    },

    editZlecenie(id) {
      this.editingId = id;
    },
updateZlecenie(zlecenie) {
    if (
        !zlecenie.first_name.trim() ||
        !zlecenie.last_name.trim()
    ) {
        this.errorMsg("Podaj imię i nazwisko.");
        return;
    }

    this.$emit("update-zlecenie", {
        id: zlecenie.id,
        first_name: zlecenie.first_name.trim(),
        last_name: zlecenie.last_name.trim()
    });
	 this.resetForm();
      //this.hide();
},


saveNewZlecenie() {
    if (
        !this.newZlecenie.first_name.trim() ||
        !this.newZlecenie.last_name.trim()
    ) {
        this.errorMsg("Podaj imię i nazwisko.");
        return;
    }

    this.$emit("save-zlecenie", {
        first_name: this.newZlecenie.first_name.trim(),
        last_name: this.newZlecenie.last_name.trim()
    });

      this.resetForm();
      //this.hide();
    },
	
    deleteZlecenie(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pracownika (zlecenie)',
        html: 'Czy na pewno chcesz usunąć wybranego pracownika (zlecenie)?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {

          this.$emit("delete-zlecenie", id);
          this.resetForm();
          //this.hide();

        }

      });
    },
	
    show() {
      this.modalObj.show();
    },
    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },


    hide() {
      this.resetForm();

      if (this.modalObj) {
        this.modalObj.hide();
      }
    }
  }
};
</script>

<style>
.position-absolute {
  background: white;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
}
</style>